import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { globalEnvironment } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ApiCallsService {
  private envBaseURL = globalEnvironment.urlPrefixV2;
  private envBaseAddURL = globalEnvironment.urlPrefixV1;

  constructor(private http: HttpClient) { }

  getProcedureDetails(proCode: string): Observable<any> {
    return this.http.get(this.envBaseURL + 'rdmInfo?fullDesc=' + proCode);
  }

  getStateBasedOnLob(lob: string): Observable<any> {
    return this.http.get(this.envBaseURL + 'statebylob?lob='+ lob);
  }

  getLobBasedOnState(state: string): Observable<any> {
    return this.http.get(this.envBaseURL + 'lobbystate?stateCode='+ state);
  }

  getPolicyNumbers(state: string, lob: string, pxCode?: string): Observable<any> {
    let newUrl = `${this.envBaseURL + 'adoptionInfo'}?state=${state}&lob=${lob}`;
    if(pxCode){
      newUrl += `&pxCode=${pxCode}`;
    }
    return this.http.get(newUrl);
  }

  getAllStateCodes(): Observable<any> {
    return this.http.get(this.envBaseURL + 'getAllStates');
  }

  validateProCd(pxCode: string): Observable<any> {
    return this.http.get(this.envBaseURL + 'validatepx?PXcode='+ pxCode);
  }

  getPolicyProCdDetails(reqObj: any) {
    return this.http.post(this.envBaseURL + 'RFI/recommendations', reqObj);
  }

  downloadToExcel(reqObj: any) {
    return this.http.post(this.envBaseURL + 'exportrfi', reqObj, { responseType: "blob"});
  }

  downloadstatePlantypeExcel(reqObj: any) {
    return this.http.post(this.envBaseURL + 'exportstaterfi', reqObj, { responseType: "blob"});
  }

  searchLogs(reqObj: any) {
    return this.http.post(this.envBaseAddURL + 'savesearchlogs', reqObj);
  }

  downloadLogs(reqObj: any) {
    return this.http.post(this.envBaseAddURL + 'savedownloadlogs', reqObj);
  }

  postFeedback(reqObj: any) {
    return this.http.post(this.envBaseAddURL + 'feedback', reqObj);
  }
}
